import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';
import {
    IWineshopResponse,
    IWineShopsEventsResponse,
    IWineshopsListResponse,
    IWineShopsProductsResponse,
} from 'modules/wineshops-list/models';
import {buildHeaders} from 'core/helpers/api/headers';
import {ENDPOINT_WINESHOPS} from 'modules/wineshops-list/constants';

const ENDPOINT_WINESHOPS_EVENTS = `${API_VERSION}/events`;

const ENDPOINT_WINESHOPS_PRODUCTS = `${API_VERSION}/catalog/products/winery`;

export const wineShopsListApiServices = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getWineShopList: builder.query<IWineshopsListResponse, void>({
            query: () => {
                return {
                    url: `${ENDPOINT_WINESHOPS}?pageSize=100`,
                    method: 'GET',
                    headers: buildHeaders({withSeo: 'list'}),
                };
            },
        }),

        getWineShopX: builder.query<IWineshopResponse, {code: string}>({
            query: ({code}) => {
                return {
                    url: `${ENDPOINT_WINESHOPS}/${code}`,
                    method: 'GET',
                    headers: buildHeaders({withSeo: 'detail'}),
                };
            },
        }),

        getWineShopEvents: builder.query<IWineShopsEventsResponse, {code: string; pageSize: number}>({
            query: (query) => {
                const queryFilter = query.code ? `&filter[winery][]=${query.code}` : '';
                return `${ENDPOINT_WINESHOPS_EVENTS}?pageSize=${query.pageSize}${queryFilter}`;
            },
        }),

        // getWineShopPayments: builder.query({
        //     query: () => `${ENDPOINT_WINESHOPS}`,
        // }),

        getWineShopProducts: builder.query({
            query: (query) => `${ENDPOINT_WINESHOPS_PRODUCTS}/${query.code}?pageSize=${query.pageSize}`,
            transformResponse: (response: {data: IWineShopsProductsResponse}) => response.data.items || {},
        }),
    }),
});

export const {
    useGetWineShopListQuery,
    useLazyGetWineShopListQuery,
    useGetWineShopEventsQuery,
    useGetWineShopProductsQuery,
    useGetWineShopXQuery,
} = wineShopsListApiServices;

export const {getWineShopList, getWineShopX, getWineShopProducts} = wineShopsListApiServices.endpoints;
